import { SummaryNoteTypeEnum } from '../Enum/SummaryNoteTypeEnum';
import { DocumentEngagement } from '../Models/DocumentEngagements/DocumentEngagement.model';
import { SummaryNote } from '../Models/DocumentEngagements/SummaryNote.model';

export const isSummaryNoteConfirmationDisabled = (contacted: boolean, note: SummaryNote): boolean =>
    contacted === false && note.Type !== SummaryNoteTypeEnum.ProgressNote;

export const setSummaryNotesContacted = (notes: SummaryNote[], contacted: boolean): SummaryNote[] =>
    notes.map((note) => (note.Type === SummaryNoteTypeEnum.ProgressNote ? note : { ...note, IsConfirm: contacted }));

export const normalizeSummaryNoteConfirmation = (draft: DocumentEngagement): DocumentEngagement =>
    draft.Contacted === false
        ? { ...draft, SummaryNotes: setSummaryNotesContacted(draft.SummaryNotes || [], false) }
        : draft;

export const getProgressNoteConfirmation = (notes: SummaryNote[]): boolean =>
    notes.find((note) => note.Type === SummaryNoteTypeEnum.ProgressNote)?.IsConfirm ?? true;
